import { render, staticRenderFns } from "./CommunityCommentUploadImageModal.vue?vue&type=template&id=288c0036&scoped=true&"
import script from "./CommunityCommentUploadImageModal.vue?vue&type=script&lang=js&"
export * from "./CommunityCommentUploadImageModal.vue?vue&type=script&lang=js&"
import style0 from "./CommunityCommentUploadImageModal.vue?vue&type=style&index=0&id=288c0036&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288c0036",
  null
  
)

export default component.exports